import React from 'react';

import appendQuery from 'append-query';
// eslint-disable-next-line lodash/import-scope
import { get } from 'lodash';
import PropTypes from 'prop-types';

import appConfig from '@nerdwallet/app-config';
import { Button, Heading } from '@nerdwallet/currency';
import { iconUri } from '@nerdwallet/nw-client-lib/cdn';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import { useSegmentImpressionHook } from '../../lib/analytics/segment-impression';
import useSegmentClicked from '../../lib/analytics/use-segment-clicked';

import ImageSizes from '../../config/images/imageSizes';
import transformToMRTInputs from '../../lib/transform-to-mrt-inputs';

// CSS
require('./rate-table-cta.less');

const RateTableCta = ({
  data,
  buttonText,
  headerText,
  href,
  img,
  summaryText,
  trackingFormName,
}) => {
  const renderImpression = () => {
    const trackingName = 'mortgages-embedded-reco';

    return (
      <ElementImpression
        id={`${trackingName}=mrt`}
        elementName={trackingName}
        elementPosition={0}
        sectionCategory="embedded-reco"
      />
    );
  };

  const getUrl = () => {
    return appendQuery(href, {
      ...transformToMRTInputs(data),
      bypass: true,
      trk: `${trackingFormName}_embedreco_mrt`,
    });
  };

  const absoluteUrl = `${appConfig.SITE_BASE_URL}${getUrl()}`;

  const {
    eventId: linkViewedId,
    pageViewId,
    ref: linkRef,
  } = useSegmentImpressionHook({
    eventType: 'link_viewed',
    attributes: {
      entity_name: 'custom_cta',
      link_copy: buttonText,
      section_name: null,
      link_position: null,
      destination_url: absoluteUrl,
      destination_content_id: 678453,
    },
  });

  const { ref: ctaRef } = useSegmentClicked({
    attributes: {
      entity_name: 'custom_cta',
      parent_event_id: linkViewedId,
      pageview_id: pageViewId,
    },
  });

  const getSummaryText = () => {
    if (summaryText) {
      return summaryText;
    }

    return `Get personalized mortgage rates for ${get(
      data,
      'inputs.purchaseAddress.city'
    )}, ${get(data, 'inputs.purchaseAddress.state')}`;
  };

  const renderHeader = () => {
    return (
      <Heading level="4" className="rate-table-cta-header">
        {headerText}
      </Heading>
    );
  };

  const renderImage = () => {
    return (
      <img
        className="rate-table-cta-img"
        {...ImageSizes.largeIcon.measures}
        src={img}
        alt=""
      />
    );
  };

  const renderSummary = () => {
    return <p className="rate-table-cta-summary">{getSummaryText()}</p>;
  };

  return (
    <div className="rate-table-cta">
      <a
        className="rate-table-cta-link"
        href={getUrl()}
        target="_blank"
        ref={linkRef}
      >
        {renderHeader()}
        {renderImage()}
        {renderSummary()}
        {renderImpression()}
        <div className="rate-table-cta-button">
          <Button ref={ctaRef}>{buttonText}</Button>
        </div>
      </a>
    </div>
  );
};

RateTableCta.displayName = 'RateTableCta';

RateTableCta.propTypes = {
  data: PropTypes.object.isRequired, // entire reducer
  // UI props
  buttonText: PropTypes.string,
  headerText: PropTypes.string,
  href: PropTypes.string,
  img: PropTypes.string,
  summaryText: PropTypes.string,
  trackingFormName: PropTypes.string.isRequired,
};

RateTableCta.defaultProps = {
  buttonText: 'GET STARTED',
  headerText: 'See latest mortgage rates',
  href: '/mortgages/mortgage-rates',
  img: iconUri('iPad_graph'),
  summaryText: null,
};

export default RateTableCta;
